import React, { useRef, useState } from "react";

//Importar íconos de Material UI.
import { AccountCircle } from '@mui/icons-material/';

//Importar íconos helpers.
import { verifyCondition_herderChat } from "../../../const/conditionalConstants/headerChatRender";
import MenuAsingOperator from "./local_components/Menu/MenuAsingOperator.jsx"; 
import AssingOperator from "../../common/Buttons/AssingOperator.jsx";
import { userIsAdmin } from "../../../const/conditionalConstants/userIsAdmin.js";

// HeaderChat: Componenete que renderiza el encabezado del chat seleccionado, y el menú para asignar un operador.

const HeaderChat = ({ socketConnected, setSessionsChatSelected, chatName, setChatData, idChat, operatorAsinged}) => {

    const containerAsignRef = useRef(null); //Referencia para el contendor del botón para asignar chat.
    const [openMenuChatAsign, setOpenMenuChatAsing] = useState(false); //Estado para abrir y cerrar el submenú de asignar chat.
    const isAdmin = userIsAdmin(); //Verificar si el usuario es o no admin.

    // Verificar condiciones para renderizar componentes.
    let HEADER_CONDITION = verifyCondition_herderChat(socketConnected, chatName);

    const onChangeOperador = (operadorSelected) => { //Función de callback para asignar un operador.
        setOpenMenuChatAsing(false); //Cerrar el submenu para asignar un operador.
    };

    return (
        <>
            {HEADER_CONDITION && <div className="container-chat__chat-header" >
                <div className="name-client-wiht-icon" style={{ width: isAdmin ? "73%" : "100%" }}>
                    {<AccountCircle sx={{ color: 'var(--ligth-color)', fontSize: '35px', marginRight: '10px' }}/>}
                    <span>{chatName}</span>
                </div>

                {isAdmin && <AssingOperator operatorAsinged={operatorAsinged} containerAsignRef={containerAsignRef} 
                openMenuChatAsign={openMenuChatAsign} setOpenMenuChatAsing={setOpenMenuChatAsing}/>}

            </div>}

            {/*----Contenedor del Menú desplegable para asignar el chat----*/}
            {openMenuChatAsign &&
                <MenuAsingOperator setSessionsChatSelected={setSessionsChatSelected}
                    idChat={idChat} containerAsignRef={containerAsignRef} setChatData={setChatData}
                    onChangeOperador={onChangeOperador} setOpenMenuChatAsing={setOpenMenuChatAsing}
                />
            }
        </>
    );
};
export default HeaderChat;